import React from 'react';
import ItemsListUnsubmitted from './ItemsListUnsubmitted';
import { useAppTexts } from '../../hooks/useAppTexts';
import { useLoadedFirebaseData } from '../../firebase/hooks';

const ItemsList = () => {
  const { publicConfig: appThemeData, order } = useLoadedFirebaseData();
  const appTexts = useAppTexts();

  return (
    <React.Fragment>
      <title>{`${appThemeData.appTitle} - ${appTexts.itemsList.pageTitle} ${order?.name}`}</title>
      <ItemsListUnsubmitted />
    </React.Fragment>
  );
};

export default ItemsList;
